<template>
  <div class='mb-3'>
    <v-card outlined>
      <div class='route-container route rounded grey lighten-4'>
        <div style="height: 5px;" width='100%' class='blue-grey lighten-4 rounded-top'></div>
        <!-- <span>{{ route.id }}</span><span>{{ ' ' + route.date }}</span> -->
        <!-- temp debug code above.  leaving in until know this is working properly -->

        <div class="route-header-row">  <!-- Top row -->
              
          <v-tooltip open-delay='700' top>
            <template v-slot:activator='{ on }'>
              <v-btn x-small icon class='mr-auto' v-on='on' :disabled='disableMapping' @click='mapRoute'>
                <v-icon small color='grey darken-1'>mdi-map-marker</v-icon>
              </v-btn>
            </template>
            <span>Map route (beta)</span>
          </v-tooltip>
            
          <span @click='showRouteItems = !showRouteItems' class='route-header pilot primary--text'>{{ lead }}</span>

          <v-tooltip open-delay='700' top>
            <template v-slot:activator='{ on }'>
              <v-btn x-small class='ml-auto' icon v-on='on' :disabled='isLoading' @click='editRoute'>
                <v-icon small>mdi-pencil-outline</v-icon>
              </v-btn>
            </template>
            <span>Edit route details</span>
          </v-tooltip>

        </div>

        <div class="route-header-row">  <!-- Middle row -->
           
          <span @click='showRouteItems = !showRouteItems' class='my-n1 caption route-header info--text'>{{ copilot }}</span>

        </div>
        <template v-for='other_copilot in other_copilots'>
          <div class="route-header-row" :key='other_copilot.id'>
            <span @click='showRouteItems = !showRouteItems' class='my-n1 caption route-header info--text'>{{ other_copilot.pilot_data.name_display }}</span>
          </div>
        </template>

        <div class="route-header-row">  <!-- Bottom row -->

          <div class='mr-auto button-holder'>
            <v-tooltip v-if='areWOsSelected' open-delay='700' top>
              <template v-slot:activator='{ on }'>
                <v-btn x-small icon v-on='on' v-if='areWOsSelected' :disabled='isLoading' @click='addWOsToRoute'>
                  <v-icon color='grey darken-2' small>mdi-plus-circle-outline</v-icon>
                </v-btn>
              </template>
              <span>Add selected WOs to Route</span>
            </v-tooltip>
          </div>

          <span @click='showRouteItems = !showRouteItems' class='caption route-header vehicle grey--text'>{{ vehicle }}</span>

          <div class='ml-auto button-holder'>
            <v-tooltip open-delay='700' top>
              <template v-slot:activator='{ on }'>
                <v-btn x-small icon v-on='on' @click='toggleRouteItems'>
                  <v-icon small>{{showRouteItems ? 'mdi-arrow-collapse-up' : 'mdi-arrow-expand-down'}}</v-icon>
                </v-btn>
               </template>
              <span v-if='route.wos === null'>Load Route Info</span>
              <span v-else>{{showRouteItems ? 'Collapse Route' : 'Expand Route'}}</span>
            </v-tooltip>
          </div>

        </div>

        <v-divider></v-divider>

        <div v-if='(route.wos !== null)' class="route-header-row">  <!-- Route Details Row -->

          <v-tooltip open-delay='700' top>
            <template v-slot:activator='{ on }'>
              <div class='mr-auto ml-1 number-holder text-align-center' v-on='on'>
                <span class='body-2 success--text'>{{ completedWoCount }}</span>
                <span v-if='attemptedWoCount > 0' class='body-2 warning--text'>{{ " / " + attemptedWoCount }}</span>
                <span class='body-2 primary--text'>{{ " / " + totalWoCount }}</span>
              </div>
            </template>
            <span>{{ (attemptedWoCount > 0) ? 'completed / attempted / total' : 'completed / total' }} </span>
          </v-tooltip>


          <div v-if='showRouteItems && (route.wos !== null && route.wos.length > 0)' style='margin-top: -1px;'>
            <v-btn x-small icon @click='selectAll'><v-icon small>mdi-checkbox-marked-outline</v-icon></v-btn>
            <v-btn x-small icon @click='deselectAll'><v-icon small>mdi-checkbox-blank-outline</v-icon></v-btn>
          </div>

          <span class='ml-auto mr-1 number-holder revenue text-right body-2 success--text'>{{ routeRevenue | intMoney }}</span>

        </div>

        <div v-if='showRouteItems && (route.wos !== null && route.wos.length === 0)' class="route-header-row white flex-column">
          <v-divider></v-divider>
          <span style='margin-bottom: -6px; margin-top: -6px' class='grey--text text-center overline'>Empty Route</span>
        </div>
  <!-- everything above can be separated into a route header component if desired -->

            <wo-list
              v-if='showRouteItems && (route.wos !== null && route.wos.length > 0)'
              :routeDate='route.date'
              :items='route.wos'
              :showInsertBox='showInsertBox'
              :isLoading='isLoading'
              @openCrewVisits='openCrewVisits'
              @openQuickView='openQuickView'
              @woClicked='woClicked'
              @insertBefore='insertBefore'
              @updateWO='updateWO'
              hideScroll
            ></wo-list>
            <v-btn
              v-if='showInsertBox && showRouteItems'
              small
              block
              tile
              depressed
              :disabled='isLoading'
              @click="addWOsToRoute"
            >
              Add to end
            </v-btn>

        <div style="height: 5px;" width='100%' class='blue-grey lighten-4 rounded-bottom'></div>
      </div>
    </v-card>
    <route-details-dialog
      :showDialog='showEditRoute'
      :route='routeCopy'
      @deleteRoute='deleteRoute'
      @cancel='showEditRoute = false'
      @update='update'
    ></route-details-dialog>

  </div>
</template>

<script>
import RouteDetailsDialog from './RouteDetailsDialog'
import WOList from './WOList'
import _ from 'lodash'

export default {
  props: {
    route: {
      required: true
    },
    isLoading: {
      required: true
    },
    // For toggling open all routes to see the WOs
    showWOs: {
      required: false,
      type: Boolean,
      default: false
    },
    showInsertBox: {
      required: true
    },
  },
  data: () => ({
    showEditRoute: false,
    showRouteItems: false,
    routeCopy: {},
  }),
  computed: {
    lead () {
      if (this.route.is_template) {
        return 'ROUTE TEMPLATE'
      } else if (this.route.lead) {
        return this.route.lead_obj.name_display
      }
      return '(no lead)'
    },
    copilot () {
      if (this.route.is_template) {
        return this.route.description
      } else {
        if (this.route.copilot) {
          return this.route.copilot_obj.name_display
        }
      }
      return '' 
    },
    other_copilots(){
      return this.route.other_copilots;
    },
    vehicle () {
      if (!this.route.is_template) {
        if(this.route.vehicle_obj !== null && this.route.vehicle_obj !== undefined){
          return this.route.vehicle_obj.name;
        }
      }
      return '' 
    },
    areWOsSelected () {
      return this.$store.getters.areWOsSelected
    },
    totalWoCount () {
      if (this.route.wos) {
        return this.route.wos.length > 0 ? this.route.wos.length : '0'
      } else {
        return 0
      }
    },
    attemptedWoCount () {
      let attempted = _.filter(this.route.wos, function(w) { return w.is_attempted; });
      return attempted.length
    },
    completedWoCount () {
      let completed = _.filter(this.route.wos, function(w) { return w.is_complete; });
      return completed.length
    },
    routeRevenue () {
      return _.sumBy(this.route.wos, 'minimum_price')
    },
    storeRoutes () {
      return this.$store.state.schedule.selectedRoutes
    },
    disableMapping () {
      if (!this.route.wos) {
        return true
      } else if (!this.route.wos.length) {
        return true
      } 
      return false
    }
  },
  watch: {
    showWOs () {
      // console.log('showWOs changed - sending to toggle')
      if (this.showRouteItems !== this.showWOs) {
        this.toggleRouteItems() 
      }
    },
  },
  created () {
    this.showRouteItems = this.showWOs
    // console.log('route ' + this.route.id +' created hook: showRoute = ' +  this.showRouteItems + ', showWOs = ' + this.showWOs)
    if (this.showRouteItems && (this.route.wos === null) ) {
      this.$emit('getFullRoute', this.route.id)
    }
    if (this.storeRoutes.find(r => r.id === this.route.id)) {
      this.showRouteItems = true
    }
  },
  methods: {
    mapRoute () {
      const link = document.createElement('a')
      const invURL = this.$router.resolve({ name: 'MapRoute', params: { id: this.route.id } })
      link.target = '_blank'
      link.href = invURL.href
      link.click()
    },
    toggleRouteItems () {
      if (this.showRouteItems === false && this.route.wos === null) {
        this.$emit('getFullRoute', this.route.id) 
      }
      this.showRouteItems = !this.showRouteItems
    },
    editRoute () {
      this.routeCopy = _.cloneDeep(this.route)
      this.showEditRoute = true
    },
    update (route) {
      this.$emit('updateRoute', route)
      this.showEditRoute = false
    },
    woClicked (wo) {
      if (wo.is_selected === true) {
        this.$emit('deselect', [wo])
      } else {
        this.$emit('select', [wo])
      }
    },
    selectAll () {
      let tmpWOs = _.filter(this.route.wos, function(a) { return a.is_selected === false && a.is_complete === false })
      this.$emit('select', tmpWOs)
    },
    deselectAll () {
      let tmpWOs = this.route.wos.filter(w => w.is_selected === true)
      this.$emit('deselect', tmpWOs)
    },
    addWOsToRoute () {
      this.$emit('moveWOs', this.route.id)
    },
    insertBefore (wo) {
      this.$emit('moveWOs', this.route.id, wo.id)
    },
    openQuickView (wo) {
      this.$emit('openQuickView', wo)
    },
    deleteRoute (route) {
      this.$emit('deleteRoute', route)
    },
    openCrewVisits (wo) {
      this.$emit('openCrewVisits', wo)
    },
    updateWO (wo) {
      this.$emit('updateWO', wo)
    }
  },
  components: {
    'wo-list': WOList,
    'route-details-dialog': RouteDetailsDialog
  }
}
</script>

<style scoped>

.route {
  border: 0px solid rgba(0,0,0,0.3);
}

.rounded {
  border-radius: 5px;
}

.rounded-top {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.route-header {
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.route-header-row {
  display: flex;
  justify-content: center;
}

.route-title {
  font-size: 1rem;
  line-height: 1rem;
  text-transform: uppercase;
}

.route-details {
  font-size: 0.8rem;
  line-height: 0.8rem;
}

.route-container {
  width: 220px !important;
  /*margin-bottom: 2px;*/
}

.pilot {
  font-size: 13px;
  font-weight: 600;
}

.button-holder {
  height: 20px;
  width: 20px;
  display:flex;
  align-items:center;
  justify-content:center;
}

.number-holder {
  height: 20px;
  width: 60px;
  align-items:center;
  white-space: nowrap;
}

.revenue {
  padding-top: 3px;
}

</style>
